export default __webpack_public_path__ + "static/media/img-49-phoenix.b3f39ae5.jpg";